// extracted by mini-css-extract-plugin
module.exports = {"sidenote":"StepSendInquiryForm_sidenote__gO2EE","alert":"StepSendInquiryForm_alert__GYtby","ageNotificationScrollLayer":"StepSendInquiryForm_ageNotificationScrollLayer__1CQyQ"};